import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&lang=css"

export default script